<template>
  <div id="home">
    <my-header ></my-header>
    <div class="image-store height-auto">
      <img src="/static/images/cover-store.jpg" />
    </div>
    <div class="pd20">

      <h3 class="text-center">Cửa hàng gần nhất</h3>
      <loading v-if="waiting_location" class="mt10 text-center" :text="'Please accept location to show nearest store'|translate"></loading>
      <div v-if="!waiting_location" class="home-div">
            <current-address-control :object="search_params" ></current-address-control>
            <loading v-if="working" :text="'Please wait'|translate"></loading>
            <div class="row mt40" v-if="!working">
              <div class="pd20">
                <div class="alert alert-info" v-if="show_suggestion" >
                   <p>Không có cửa hàng nào trong bán kính 3km của bạn</p><br/>
                  <router-link class="btn btn-primary" :to="{name:'AddStore'}">{{'Register store'|translate}}</router-link>
                </div>
              </div>

              <div class="col-md-12 col-xs-12" v-if="search_result.length== 0 && !show_suggestion ">
                <div class="alert alert-info" role="alert">{{'No result'|translate}}</div>
              </div>

              <div class="col-md-6 col-xs-12 mt10"  v-for="(store) in search_result" :key="store.id">
                <div class="media search-item">
                  <div class="media-left">
                    <router-link :to="{ name: 'ProfileStore', params: { storeId: store.code }}">
                      <img
                        class="media-object border-radius-8"
                        style="width:100px;height:100px"
                        v-if="!store.banner_image"
                        src="/static/images/no-photo.jpg"
                      />
                      <img
                        class="media-object border-radius-8"
                        style="width:100px;height:100px"
                        v-if="store.banner_image"
                        :src="store.banner_image.thumb_path"
                      />
                    </router-link>
                  </div>
                  <div class="media-body">
                    <p>
                      <router-link :to="{ name: 'ProfileStore', params: { storeId: store.code }}">
                        <h4 class="media-heading">{{store.name}}</h4>
                      </router-link>
                    </p>
                    <div style="max-width:280px">
                      <p class="overflow-ellipsis"
                      >{{ store.full_address }}</p>
                    </div>

                    <p class="distance">
                      <i class="fas fa-motorcycle"></i>
                      {{roundNumber(store.distance)}} km
                    </p>
                  </div>
                </div>
              </div>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import Autocomplete from 'vuejs-auto-complete'
import advantagesearch from '@/components/elements/AdvantageSearch'
import CurrentAddressControl from '@/components/elements/CurrentAddressControl'
import LocationHelper from '@/helpers/location'
import Loading from '@/components/elements/Loading'
export default {
  name: 'Home',
  components: {
    MyHeader,
    Autocomplete,
    advantagesearch,
    CurrentAddressControl,
    Loading
  },
  data () {
    return {
      show_suggestion: false,
      waiting_location: true,
      working: true,
      search_result: [],
      search_params: {
        address: '',
        lat: null,
        lng: null,
        dist: 0
      }
    }
  },

  methods: {
    roundNumber (number) {
      return Utils.roundNumber(number)
    },
    searchStores () {
      this.working = true
      let data = {

        lat: this.search_params.lat,
        lng: this.search_params.lng,
        km: 1000,
        is_store: 1
      }

      Utils.requestV2(this, true)
        .get(`/nearby-stores/`, { params: data })
        .then(response => {
          this.working = false
          this.search_result = response.data

          this.checkSuggestion()
        })
        .catch(error => {})
    },
    checkSuggestion () {
      console.log('check suggestion')

      if (this.search_result.length > 0 && this.search_result[0].distance < 3) {
        console.log('has store under 3km')
        return
      }

      let localUser = this.$localStorage.get('user')

      console.log('localUser', localUser)
      if (!localUser) {
        return
      }
      // if ()
      Utils.requestV2(this).get(`profile`).then((response) => {
        console.log('response user', response)
        if (response.data.count_store == 0) {
          this.show_suggestion = true
        }
      })
    }
  },

  mounted () {
    LocationHelper.getMyLocationWithAddress().then((position) => {
      this.search_params.lat = position.lat
      this.search_params.lng = position.lng
      this.search_params.address = position.address
      this.waiting_location = false
      this.searchStores()
    })
  },
  beforeDestroy () {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/NearestStore.vue